import api from '../api';

const API = 'importExport';
const PENDING = `${API}_PENDING`;
const FULFILLED = `${API}_FULFILLED`;
const REJECTED = `${API}_REJECTED`;

const initialState = {
  data: { batchid: '', rows: [] },
  fetching: false,
  fetched: false,
  errors: []
};

const reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case PENDING: return {...state, fetching: true, fetched: false};
    case REJECTED: return {...initialState, errors: payload};
    case FULFILLED: return { data: { batchid: payload.data.batchid, rows: [...payload.data?.rows]} , fetching: false, fetched: true};
    default: return state;
  }
}

export default reducer;

// Action creator
export const getImportStatus = () => ({
  type: API,
  payload: api.getImportStatus(),
});